import { useSelector } from 'react-redux';
import { NewBookingState } from '../../reducers/newBooking';
import { SolvReduxState } from '../../reducers';

export const useSelectNewBooking = () => {
  return useSelector<SolvReduxState, NewBookingState>((state) => state.newBooking);
};
